import { merge, mergeWith } from 'lodash';
import localConfig from '../../public/config.js';

 

/**
 * SaaS-only overrides merged on top of defaults + public/config.js when in saas mode.
 * Extend this object as you add restrictions (same shape as Config.defaults).
 */
function getSaasOverrides() {
  return {
    customHeaderAndFooter: {
      header_url: '/static/wc/ogs-header.js',
      footer_url: '/static/wc/ogs-footer.js',
    },
    saasBlockedRouteNames: [
      'DatasetPermissions',
    ],
    forms: {
      dataset: {
        hiddenFields: [
          'kinds',
          'usergroup',
        ],
        requiredFields: [
          'display_name',
          'description',
          'keywords',
          'topics',
          'publication_date',
          'lastUpdateDate',
          'update_frequency',
          'record_type'
        ],
      },
      organisation: {
        hiddenFields: [
          'display_name',
          'acronym',
          'registration_number',
          'organisation_type',
          'website_url',
          'description',
          'jurisdiction',
          'agreement',
          'agreement_signed',
          'partner',
        ],
      },
    },
    resourceTypes: [
      'file-upload',
      'href',
    ],
    annexTypes: [
      'file-upload',
      'href',
    ],
  };
}

export default class Config {
  static defaults = {
    appTitle: "Publish - Onegeo-Suite",
    i18n: {
      defaultLocale: "fr",
      fallbackLocale: "fr",
      supportedLocales: ["fr", "en"],
    },
    isSaas: false,
    reloadInterval: 15000,
    /**
     * WC portal header/footer.
     * `false` = off ; `true` = on (URLs `/portal/wc/*`) ;
     * `{ header_url, footer_url }` = on avec URLs custom.
     */
    customHeaderAndFooter: false,
    /** In SaaS mode, replaced by `getSaasOverrides()`. */
    saasBlockedRouteNames: [],
    statistics: {
      matomoHost: '',
      matomoId: '',
    },
    services: {
      portal: {
        available: true,
        superuser: true,
      },
      maps: {
        available: false,
        superuser: true,
      },
      geocontrib: {
        available: false,
        superuser: true,
      },
      stats: {
        available: false,
        superuser: true,
      },
      geoserver: {
        available: false,
        superuser: true,
      },
      geonetwork: {
        available: false,
        superuser: true,
      },
      jurisdiction: {
        available: true,
      },
    },
    components: {
      QualityLabel: 'dataset-detail-top-anchor',
    },
    itemsPerPage: {
      datasets: 20,
      datasetPermissions: 20,
      jurisdictions: 50,
      organisations: 20,
      organisationContacts: 20,
      organisationMembers: 20,
      tasks: 20,
      users: 20,
      usergroups: 20,
      usergroupContacts: 20,
      usergroupParents: 20,
      usergroupChildren: 20,
      usergroupMembers: 20,
    },
    forms: {
      user: {
        hiddenFields: [],
        requiredFields: [
          'last_name',
          'first_name',
          'email'
        ]
      },
      organisation: {
        hiddenFields: [],
        requiredFields: [
          'display_name',
          'organisation_type'
        ]
      },
      group: {
        hiddenFields: [],
        requiredFields: [
          'name'
        ]
      },
      sphere: {
        hiddenFields: [],
        requiredFields: [
          'name'
        ]
      },
      contact: {
        hiddenFields: [],
        requiredFields: [
          'name',
          'email'
        ]
      },
      dataset: {
        hiddenFields: [],
        requiredFields: [
          'display_name',
          'description',
          'keywords',
          'topics',
          'kinds',
          'usergroup',
          'publication_date',
          'lastUpdateDate',
          'update_frequency',
          'record_type'
        ],
        extraFields: []
      },
      resource: {
        datastore: {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
          ]
        },
        'file-upload': {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
            'column_x',
            'column_y',
            'crs'
          ]
        },
        ftp: {
          superuserOnly: true,
          hiddenFields: [],
          requiredFields: [
            'display_name',
          ]
        },
        href: {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
          ]
        },
        'file-download': {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
          ]
        },
        geoserver: {
          superuserOnly: false,
          hiddenFields: [
          ],
          requiredFields: [
            'display_name',
          ]
        }
      },
      indexer: {
        hiddenFields: [],
        requiredFields: [
          'name',
          'url',
          'command',
          'scheduler',
        ]
      }
    },
    resourceTypes: [
      'datastore',
      'file-upload',
      'ftp',
      'href',
      'file-download',
      'geoserver'
    ],
    annexTypes: [
      'file-upload',
      'ftp',
      'href',
      'file-download',
    ],
    wms: {
      staticBaseUrl:'https://rec.onegeosuite.fr/maps'
    },
    features: {
      aiMetadataGeneration: {
        available: false
      }
    },
  }

  constructor() {
    Object.assign(this, merge(Config.defaults, localConfig || {}));
    if (this.isSaas) {
      mergeWith(this, getSaasOverrides(), (objValue, srcValue) => {
        if (Array.isArray(srcValue)) {
          return srcValue;
        }
      });
    }
  }

}

